import { render } from "./GenresCheckboxes.vue?vue&type=template&id=b99a3934"
import script from "./GenresCheckboxes.vue?vue&type=script&lang=js"
export * from "./GenresCheckboxes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__